import { Link } from "react-router-dom";
import { Megaphone } from "@phosphor-icons/react";
import { useBrand } from "@/context/BrandContext";

export default function GlobalBanner() {
  const { settings } = useBrand();
  if (!settings?.banner_active || !settings?.banner_text) return null;
  const content = (
    <>
      <Megaphone size={13} weight="fill" className="shrink-0" />
      <span className="truncate">{settings.banner_text}</span>
    </>
  );
  const classes =
    "fixed top-0 inset-x-0 z-[60] h-8 bg-[#FF3E00] text-white flex items-center justify-center gap-2 px-4 font-mono text-[11px] uppercase tracking-[0.22em] font-bold hover:opacity-90 transition-opacity";
  return settings.banner_link ? (
    <Link to={settings.banner_link} className={classes} data-testid="global-banner">
      {content}
    </Link>
  ) : (
    <div className={classes} data-testid="global-banner">
      {content}
    </div>
  );
}
